import { render, staticRenderFns } from "./MTableCellText.vue?vue&type=template&id=09be73da"
import script from "./MTableCellText.vue?vue&type=script&lang=js"
export * from "./MTableCellText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports